import { render, staticRenderFns } from "./RipaAutocomplete.vue?vue&type=template&id=5b6c0348"
import script from "./RipaAutocomplete.vue?vue&type=script&lang=js"
export * from "./RipaAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports